import { tracking } from '@bark/bark-core';
import {
	shouldShowLeadDetailsNewDesign,
	applyLeadDetailsNewDesignValueBadgesChanges,
} from './lead_details_redesign';

export const isLeadsListRctLoaded = () => $(`#__rctLeadsList`).children().length;

export const shouldShowLeadsListRct = () =>
	$('#__rctLeadsList').length && window?.SellerAppDashboard;

export let LeadsListRctDispatcher = null;

export function loadLeadsListRct(entityTracking) {
	if (!isLeadsListRctLoaded()) {
		window.SellerAppDashboard.launchModule('leads-list', '__rctLeadsList', {
			sellerProfileId: Number(Bark.seller.id),
			tracking: entityTracking,
			callbacks: {
				onClickProject: leadsListRctOnClickProject,
				loadMoreRecords: Bark.seller.fetchRecords,
			},
			onMount: (dispatch) => {
				LeadsListRctDispatcher = dispatch;
				setLeadsListRctState();
				trackLeadsList(entityTracking);
			},
		});
	} else {
		setLeadsListRctState();
		trackLeadsList(entityTracking);
	}
}

function trackLeadsList(entityTracking) {
	entityTracking.fireTracking('booking_list_loaded', {
		hasBookingRequest: Bark.ProjectsData.projects.some((project) =>
			Boolean(project.customer_order),
		),
		noProjects: Bark.ProjectsData.projectsTotal,
	});
}


export function setLeadsListRctState() {
	if (LeadsListRctDispatcher) {
		LeadsListRctDispatcher({
			type: 'setProjects',
			value: Bark.ProjectsData.projects,
		});

		LeadsListRctDispatcher({
			type: 'setProjectsTotal',
			value: Bark.ProjectsData.projectsTotal,
		});

		LeadsListRctDispatcher({
			type: 'setProjectToRespond',
			value: parseInt(Bark.ProjectsData.projectToRespond),
		});

		LeadsListRctDispatcher({
			type: 'setProjectToRespondType',
			value: Bark.ProjectsData.projectToRespondType,
		});

		if (Bark.seller.currentlyShownProjectId) {
			LeadsListRctDispatcher({
				type: 'setSelectedProjectId',
				value: Bark.seller.currentlyShownProjectId,
			});
		}

		LeadsListRctDispatcher({
			type: 'setListLoading',
			value: false,
		});

		LeadsListRctDispatcher({
			type: 'setLeadsListBanner',
			value: Bark?.sellerSelfObject?.leads_list_banner ?? undefined,
		});
	}
}

export function leadsListRctOnClickProject(projectId) {
	if (Bark.seller.interactingWithProject) {
		return false;
	}

	Bark.seller.renderProject(projectId, true);
	$('.right-panel').animate({ scrollTop: 0 }, 100);

	Bark.seller.projectViewed(projectId);
	if (LeadsListRctDispatcher) {
		LeadsListRctDispatcher({
			type: 'setProjectAsViewed',
			value: projectId,
		});
	}

	tracking('leads-list-redesign', 'View project', {
		project_id: projectId,
		seller_profile_id: Bark?.seller?.id,
	});

	const sellerEnquiriesBanner = $('#__rctSellerEnquiriesBanner');
	if (Bark.seller.isMobile) {
		if (sellerEnquiriesBanner.length) {
			sellerEnquiriesBanner.addClass('d-none');
		}

		if (
			$('#__rctSellerEnquiriesBanner').length &&
			!!$('#__rctSellerEnquiriesBanner').html().length
		) {
			$('.bark-header.sticky-top').css('top', $('#__rctSellerEnquiriesBanner').height());
		}
	}
}

export function leadsListRctRemoveProjectFromList(projectId) {
	Bark.seller.removeProjectFromLocalData(projectId);

	Bark.ProjectsData.projectsTotal--;
	Bark.seller.unfilteredTotal--;
	Bark.seller.updateNewHeaderLeadCounts(
		Bark.ProjectsData.projectsTotal,
		Bark.seller.unfilteredTotal,
	);
	Bark.seller.processNoRecords();
	Bark.seller.updateRecordCount();

	setLeadsListRctState();
}

export function leadsListRctNotInterested(projectId) {
	leadsListRctRemoveProjectFromList(projectId);

	if (Bark.seller.isMobile) {
		Bark.seller.hideProject();
	} else if (Bark.ProjectsData.projects.length > 0) {
		Bark.seller.showProject(Bark.ProjectsData.projects[0].project_id);
	}
}

/**
 * Value badges Rct component on Lead details
 */

let valueBadgesLeadDetailsLoaded = false;

export const isValueBadgesLeadDetailsLoaded = () => valueBadgesLeadDetailsLoaded;

export let ValueBadgesLeadDetailsRctDispatcher = null;
let BookingDetailsDispatcher = null;

export function loadValueBadgesLeadDetailsRct(project) {
	if (!isValueBadgesLeadDetailsLoaded()) {
		window.SellerAppDashboard.launchModule(
			'value-badges-lead-details',
			'__rctValueBadgesLeadDetails',
			{
				onMount: (dispatch) => {
					ValueBadgesLeadDetailsRctDispatcher = dispatch;
					setValueBadgesLeadDetailsRctState(project);

					if (shouldShowLeadDetailsNewDesign()) {
						applyLeadDetailsNewDesignValueBadgesChanges();
					}
				},
			},
		);
		valueBadgesLeadDetailsLoaded = true;
	} else {
		setValueBadgesLeadDetailsRctState(project);
	}
}

export function loadProjectDetailsBookingDetails(project, entityTracking) {
	if (!BookingDetailsDispatcher) {
		window.SellerAppDashboard.launchModule(
			'booking-details',
			'__rctProjectDetailsBookingDetails',
			{
				onMount: (dispatch) => {
					BookingDetailsDispatcher = dispatch;
					BookingDetailsDispatcher({
						type: 'setProjectDetail',
						project,
					});
				},
				sellerId: window.Bark.seller.id,
				tracking: entityTracking,
			},
		);
	} else {
		BookingDetailsDispatcher({
			type: 'setProjectDetail',
			project,
		});
	}
}

export function setValueBadgesLeadDetailsRctState(project){

	if (ValueBadgesLeadDetailsRctDispatcher) {
		ValueBadgesLeadDetailsRctDispatcher({
			type: 'setImages',
			value: project.images,
		});

		ValueBadgesLeadDetailsRctDispatcher({
			type: 'setFiles',
			value: project.files,
		});

		ValueBadgesLeadDetailsRctDispatcher({
			type: 'setProjectDetail',
			value: project.project_detail,
		});

		ValueBadgesLeadDetailsRctDispatcher({
			type: 'setCategPromo',
			value: project.categ_promo,
		});

		ValueBadgesLeadDetailsRctDispatcher({
			type: 'setIsUrgent',
			value: project.is_urgent,
		});

		ValueBadgesLeadDetailsRctDispatcher({
			type: 'setIsBuyerPhoneVerified',
			value: project.is_buyer_phone_verified,
		});

		ValueBadgesLeadDetailsRctDispatcher({
			type: 'setIsReoccurringBuyer',
			value: project.is_reoccurring_buyer,
		});

		ValueBadgesLeadDetailsRctDispatcher({
			type: 'setResubmittedProject',
			value: project.resubmitted_project,
		});

		ValueBadgesLeadDetailsRctDispatcher({
			type: 'setIsLikelyToHire',
			value: project.is_likely_to_hire,
		});

		ValueBadgesLeadDetailsRctDispatcher({
			type: 'setModalOpen',
			value: false,
		});

	}

}



